import { createApi } from '@reduxjs/toolkit/query/react';

import { CategoryResp } from '@/helpers/serverApis/getProductsInCategoryByCategoryId';
import { CategoryStrapi } from '@/types/Category';
import { MetaDataStrapi } from '@/types/MetaData';
import { ProductStrapi } from '@/types/Product';

import { flatMapProductsAdapter, metaDataAdapter } from '../adapters';
import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const metaDataApi = createApi({
  reducerPath: 'metaDataApi',
  keepUnusedDataFor: 300,
  // baseQuery: fetchBaseQuery({
  //   baseUrl: STRAPI_SERVER_URL,
  //   cache: 'no-store',
  //   prepareHeaders: headers => {
  //     const { origin, host } = globalThis.window?.location || {};
  //     headers.append('Origin', origin);
  //     headers.append('Host', host);
  //     headers.append('__Origin', origin);
  //     return headers;
  //   },
  // }),
  baseQuery: generateBaseQuseryWithReAuth({ useStrapiServer: true, basePath: '', cache: 'no-store' }),
  tagTypes: ['MetaData', 'CategoryById'],
  endpoints: builder => ({
    getMetaData: builder.query<MetaDataStrapi, { isBackoffice?: boolean }>({
      query: ({ isBackoffice }) => ({
        url: `/pawtree/meta-data${isBackoffice ? '?isBackoffice=true' : ''}`,
        next: { tags: ['MetaData'] },
      }),
      transformResponse: (response: { data: MetaDataStrapi }, meta, arg) => metaDataAdapter(response),
      providesTags: ['MetaData'],
    }),

    getCategoryDetailsById: builder.query<
      {
        categoryDetailResponse: CategoryResp | undefined;
        categoryDetailData:
          | {
              Products: ProductStrapi[];
              Category: CategoryStrapi;
            }
          | undefined;
        products: ProductStrapi[];
      },
      { id: string | number }
    >({
      query: ({ id }) => ({
        url: `/api/categories/shopping-experience/${id}`,
        next: { tags: ['MetaData'] },
        cache: 'force-cache',
      }),
      transformResponse: (response: CategoryResp, meta, arg) => {
        const categoryDetailResponse = response;
        const categoryDetailData = categoryDetailResponse
          ? flatMapProductsAdapter(categoryDetailResponse.data)
          : categoryDetailResponse;
        const products = categoryDetailData?.Products ?? ([] as ProductStrapi[]);

        return { categoryDetailResponse, categoryDetailData, products };
      },
      providesTags: ['CategoryById'],
    }),
  }),
});

export const { useGetMetaDataQuery, useGetCategoryDetailsByIdQuery } = metaDataApi;
